module.exports = __webpack_public_path__ + "img/de.805bce7f.svg";